import { render, staticRenderFns } from "./radarChart.vue?vue&type=template&id=0ffa68de&scoped=true&"
import script from "./radarChart.vue?vue&type=script&lang=ts&"
export * from "./radarChart.vue?vue&type=script&lang=ts&"
import style0 from "./radarChart.vue?vue&type=style&index=0&id=0ffa68de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa68de",
  null
  
)

export default component.exports